import { render, staticRenderFns } from "./equ-num.vue?vue&type=template&id=e6a83020&scoped=true&"
import script from "./equ-num.vue?vue&type=script&lang=js&"
export * from "./equ-num.vue?vue&type=script&lang=js&"
import style0 from "./equ-num.vue?vue&type=style&index=0&id=e6a83020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a83020",
  null
  
)

export default component.exports